import React from 'react'

function Button({
	tag: Tag = "button", // Default tag is <button>
	type = "button", // Button type for <button> elements
	href = "#", // Href for <a> elements
	size = "md",
	color = "primary",
	title = "",
	active = "",
	disabled = false,
	fullWidth = "",
	alignSelf = "",
	anyClass = "",
	attributes = {}, // Additional attributes as an object
	onclick,
}) {
	// Combine dynamic class names
	const className = `
  button 
  button--${size} 
  button--color-${color} 
  ${active} 
  ${disabled ? "disabled" : ""} 
  ${fullWidth} 
  ${alignSelf} 
  ${anyClass}
`.trim();

	// Dynamic attributes (spread remaining props)
	const additionalAttributes = { ...attributes };

	return (
		<Tag
			onClick={onclick}
			className={className}
			type={Tag === "button" ? type : undefined} // Add type only for <button>
			href={Tag === "a" ? href : undefined} // Add href only for <a>
			disabled={Tag === "button" && disabled} // Add disabled only for <button>
			{...additionalAttributes} // Spread additional attributes
		>
			<span>{title}</span>
		</Tag>
	);
}

export default Button